import { ActionType, createAsyncAction } from 'typesafe-actions'
import {
  CreateCrmRuleRequestDto,
  CreateCrmRuleResponseDto,
  GetCrmRulesRequestDto,
  GetCrmRulesResponseDto,
  UpdateCrmRuleRequestDto,
  UpdateCrmRuleResponseDto,
} from '@sparling/financial-common'

export enum ActionTypes {
  CREATE_RISK_SCORE_RULE_REQUEST = 'CREATE_RISK_SCORE_RULE_REQUEST',
  CREATE_RISK_SCORE_RULE_SUCCESS = 'CREATE_RISK_SCORE_RULE_SUCCESS',
  CREATE_RISK_SCORE_RULE_FAILURE = 'CREATE_RISK_SCORE_RULE_FAILURE',

  GET_RISK_SCORE_RULES_REQUEST = 'GET_RISK_SCORE_RULES_REQUEST',
  GET_RISK_SCORE_RULES_SUCCESS = 'GET_RISK_SCORE_RULES_SUCCESS',
  GET_RISK_SCORE_RULES_FAILURE = 'GET_RISK_SCORE_RULES_FAILURE',

  GET_RISK_SCORE_RULE_REQUEST = 'GET_RISK_SCORE_RULE_REQUEST',
  GET_RISK_SCORE_RULE_SUCCESS = 'GET_RISK_SCORE_RULE_SUCCESS',
  GET_RISK_SCORE_RULE_FAILURE = 'GET_RISK_SCORE_RULE_FAILURE',

  UPDATE_RISK_SCORE_RULE_REQUEST = 'UPDATE_RISK_SCORE_RULE_REQUEST',
  UPDATE_RISK_SCORE_RULE_SUCCESS = 'UPDATE_RISK_SCORE_RULE_SUCCESS',
  UPDATE_RISK_SCORE_RULE_FAILURE = 'UPDATE_RISK_SCORE_RULE_FAILURE',

  DELETE_RISK_SCORE_RULE_REQUEST = 'DELETE_RISK_SCORE_RULE_REQUEST',
  DELETE_RISK_SCORE_RULE_SUCCESS = 'DELETE_RISK_SCORE_RULE_SUCCESS',
  DELETE_RISK_SCORE_RULE_FAILURE = 'DELETE_RISK_SCORE_RULE_FAILURE',
}

export const {
  request: createRiskScoreRuleRequest,
  success: createRiskScoreRuleSuccess,
  failure: createRiskScoreRuleFailure,
} = createAsyncAction(
  ActionTypes.CREATE_RISK_SCORE_RULE_REQUEST,
  ActionTypes.CREATE_RISK_SCORE_RULE_SUCCESS,
  ActionTypes.CREATE_RISK_SCORE_RULE_FAILURE,
)<CreateCrmRuleRequestDto, CreateCrmRuleResponseDto, Error>()

export const {
  request: getRiskScoreRulesRequest,
  success: getRiskScoreRulesSuccess,
  failure: getRiskScoreRulesFailure,
} = createAsyncAction(
  ActionTypes.GET_RISK_SCORE_RULES_REQUEST,
  ActionTypes.GET_RISK_SCORE_RULES_SUCCESS,
  ActionTypes.GET_RISK_SCORE_RULES_FAILURE,
)<GetCrmRulesRequestDto, GetCrmRulesResponseDto, Error>()

export const {
  request: getRiskScoreRuleRequest,
  success: getRiskScoreRuleSuccess,
  failure: getRiskScoreRuleFailure,
} = createAsyncAction(
  ActionTypes.GET_RISK_SCORE_RULE_REQUEST,
  ActionTypes.GET_RISK_SCORE_RULE_SUCCESS,
  ActionTypes.GET_RISK_SCORE_RULE_FAILURE,
)<{ id: number }, CreateCrmRuleResponseDto, Error>()

export const {
  request: updateRiskScoreRuleRequest,
  success: updateRiskScoreRuleSuccess,
  failure: updateRiskScoreRuleFailure,
} = createAsyncAction(
  ActionTypes.UPDATE_RISK_SCORE_RULE_REQUEST,
  ActionTypes.UPDATE_RISK_SCORE_RULE_SUCCESS,
  ActionTypes.UPDATE_RISK_SCORE_RULE_FAILURE,
)<UpdateCrmRuleRequestDto & { id: number }, UpdateCrmRuleResponseDto, Error>()

export const {
  request: deleteRiskScoreRuleRequest,
  success: deleteRiskScoreRuleSuccess,
  failure: deleteRiskScoreRuleFailure,
} = createAsyncAction(
  ActionTypes.DELETE_RISK_SCORE_RULE_REQUEST,
  ActionTypes.DELETE_RISK_SCORE_RULE_SUCCESS,
  ActionTypes.DELETE_RISK_SCORE_RULE_FAILURE,
)<{ id: number }, { id: number }, Error>()

export type CrmRulesAction = ActionType<
  | typeof createRiskScoreRuleRequest
  | typeof createRiskScoreRuleSuccess
  | typeof createRiskScoreRuleFailure
  | typeof getRiskScoreRulesRequest
  | typeof getRiskScoreRulesSuccess
  | typeof getRiskScoreRulesFailure
  | typeof getRiskScoreRuleRequest
  | typeof getRiskScoreRuleSuccess
  | typeof getRiskScoreRuleFailure
  | typeof updateRiskScoreRuleRequest
  | typeof updateRiskScoreRuleSuccess
  | typeof updateRiskScoreRuleFailure
  | typeof deleteRiskScoreRuleRequest
  | typeof deleteRiskScoreRuleSuccess
  | typeof deleteRiskScoreRuleFailure
>
